// extracted by mini-css-extract-plugin
module.exports = {"PageNotFound":"PageNotFound_PageNotFound__hKbpK","Content":"PageNotFound_Content__1oeYD","List":"PageNotFound_List__2tgN6","Link":"PageNotFound_Link__2cq7q"};